import React from 'react';

export default function Logo({ size = 40 }) {
  const s = size / 40;
  return (
    <svg width={size} height={size * 1.1} viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* ring górny */}
      <circle cx="20" cy="7" r="5.5" fill="none" stroke="#C9A84C" strokeWidth="2"/>
      <circle cx="20" cy="7" r="2.2" fill="#C9A84C"/>
      {/* poprzeczka */}
      <line x1="4" y1="14" x2="36" y2="14" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="4" cy="14" r="2.5" fill="#C9A84C"/>
      <circle cx="36" cy="14" r="2.5" fill="#C9A84C"/>
      {/* shaft */}
      <line x1="20" y1="14" x2="20" y2="36" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round"/>
      {/* flukes */}
      <path d="M20 36 L8 41 L7 35" fill="none" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 36 L32 41 L33 35" fill="none" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7" cy="35" r="2.2" fill="#C9A84C"/>
      <circle cx="33" cy="35" r="2.2" fill="#C9A84C"/>
    </svg>
  );
}
